module.exports = __webpack_public_path__ + "img/tax_t.10556dc1.png";